import {
  Alert,
  Button,
  FormContainer,
  HideIcon,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  TextField,
  ViewIcon,
} from '@all-manager/design-system-v2';
import { Navigate } from 'react-router-dom';
import AuthLayout from '../../../layout/AuthLayout/AuthLayout';
import { useLogin } from './useLogin';

const Login = () => {
  const hook = useLogin();

  if (hook.user) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthLayout title="Connexion">
      <FormContainer onSubmit={hook.handleSubmit} noValidate>
        {hook.error ? <Alert severity="error">{hook.error}</Alert> : null}

        <Stack spacing={2}>
          <TextField
            required
            fullWidth
            id="email"
            label="Adresse email"
            name="email"
            type="email"
            autoComplete="email"
            value={hook.email}
            onChange={hook.handleEmailChange}
          />
          <Stack spacing={0.5} alignItems="flex-start">
            <TextField
              required
              fullWidth
              id="password"
              name="password"
              label="Mot de passe"
              autoComplete="current-password"
              value={hook.password}
              onChange={hook.handlePasswordChange}
              type={hook.showPassword ? 'text' : 'password'}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        tooltip={hook.showPassword ? 'Masquer la saisie' : 'Afficher la saisie'}
                        onClick={hook.handleTogglePassword}
                        edge="end"
                      >
                        {hook.showPassword ? <HideIcon /> : <ViewIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Link href="/forgot-password" onClick={hook.handleForgotPasswordClick} variant="body2">
              Mot de passe oublié ?
            </Link>
          </Stack>
        </Stack>

        <Button type="submit" fullWidth variant="contained" loading={hook.isSubmitting}>
          Se connecter
        </Button>
      </FormContainer>
    </AuthLayout>
  );
};

export default Login;
